import { defineMessages } from 'react-intl';
export default defineMessages({
    legendHeavy: {
        id: 'weatherMap.legendHeavy',
        defaultMessage: 'Heavy'
    },
    legendLight: {
        id: 'weatherMap.legendLight',
        defaultMessage: 'Light'
    },
    legendLightningHelp: {
        id: 'weatherMap.legendLightningHelp',
        defaultMessage: "Colour shows each strike's age over the last {minutes} minutes — most recent in white, oldest in dark red."
    },
    legendNewest: {
        id: 'weatherMap.legendNewest',
        defaultMessage: 'Newest'
    },
    legendOldest: {
        id: 'weatherMap.legendOldest',
        defaultMessage: 'Oldest'
    },
    legendStationsHelp: {
        id: 'weatherMap.legendStationsHelp',
        defaultMessage: 'Marker colour reflects the value of the selected metric.'
    },
    lightningDataAttribution: {
        id: 'weatherMap.lightningDataAttribution',
        defaultMessage: 'Lightning data: Blitzortung.org'
    },
    lightningStrikes: {
        id: 'weatherMap.lightningStrikes',
        defaultMessage: 'Lightning strikes'
    },
    lightningStrikesDescription: {
        id: 'weatherMap.lightningStrikesDescription',
        defaultMessage: 'Display real-time lightning strikes on the map'
    },
    mapLayers: {
        id: 'weatherMap.mapLayers',
        defaultMessage: 'Map layers'
    },
    mapLegend: {
        id: 'weatherMap.mapLegend',
        defaultMessage: 'Map legend'
    },
    mapMode: {
        id: 'weatherMap.mapMode',
        defaultMessage: 'Map mode'
    },
    modeObservations: {
        id: 'weatherMap.modeObservations',
        defaultMessage: 'Observations'
    },
    modeForecast: {
        id: 'weatherMap.modeForecast',
        defaultMessage: 'Forecast'
    },
    mapNameForecast: {
        id: 'weatherMap.mapNameForecast',
        defaultMessage: 'Forecast map, {model}, {variable}'
    },
    showingForecast: {
        id: 'weatherMap.showingForecast',
        defaultMessage: 'Showing forecast: {model}, {variable}'
    },
    mapNameObservations: {
        id: 'weatherMap.mapNameObservations',
        defaultMessage: 'Weather map, observations'
    },
    radarDataAttribution: {
        id: 'weatherMap.radarDataAttribution',
        defaultMessage: 'Radar data: NOAA / EUMETNET OPERA / Radar-DPC via LibreWXR'
    },
    rainRadar: {
        id: 'weatherMap.rainRadar',
        defaultMessage: 'Rain radar'
    },
    radarCardLabel: {
        id: 'weatherMap.radarCardLabel',
        defaultMessage: 'Rain radar at {time}'
    },
    radarUnavailable: {
        id: 'weatherMap.radarUnavailable',
        defaultMessage: 'Radar unavailable'
    },
    radarLoading: {
        id: 'weatherMap.radarLoading',
        defaultMessage: 'Loading rain radar'
    },
    radarTime: {
        id: 'weatherMap.radarTime',
        defaultMessage: 'Radar time'
    },
    rainRadarDescription: {
        id: 'weatherMap.rainRadarDescription',
        defaultMessage: 'Display rain radar overlay on the map'
    },
    resetBearing: {
        id: 'weatherMap.resetBearing',
        defaultMessage: 'Drag to rotate the map, click to reset north'
    },
    weatherflowNCRain: {
        id: 'weatherMap.weatherflowNCRain',
        defaultMessage: 'NC Rain (Nearcast Rain)'
    },
    weatherflowNCRainDescription: {
        id: 'weatherMap.weatherflowNCRainDescription',
        defaultMessage: 'NC Rain is an additional data source provided via the Tempest Weather System, powered by Nearcast Technology. NC Rain data is an estimate of the average rainfall accumulation around your Tempest at the neighborhood level'
    },
    weatherMap: {
        id: 'weatherMap.weatherMap',
        defaultMessage: 'Weathermap'
    },
    weatherMapMetaDescription: {
        id: 'weatherMap.weatherMapMetaDescription',
        defaultMessage: 'SmartMixin provides interactive weather and radar maps for weather conditions for locations worldwide.'
    },
    stationMarkerName: {
        id: 'weatherMap.stationMarkerName',
        defaultMessage: '{metric} {value}, one station'
    },
    clusterMarkerName: {
        id: 'weatherMap.clusterMarkerName',
        defaultMessage: '{metric} {value}, median of {count, plural, one {# station} other {# stations}}, zoom in'
    },
    stationMarkerWindValue: {
        id: 'weatherMap.stationMarkerWindValue',
        defaultMessage: '{speed}, from {direction}'
    },
    stationMarkersHint: {
        id: 'weatherMap.stationMarkersHint',
        defaultMessage: 'Arrow keys move between stations'
    },
    zoomIn: {
        id: 'weatherMap.zoomIn',
        defaultMessage: 'Zoom in'
    },
    zoomOut: {
        id: 'weatherMap.zoomOut',
        defaultMessage: 'Zoom out'
    }
});
